import * as React from 'react';
import { SVGProps } from 'react';
const SvgIcMedicalTests = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 52 52"
    {...props}
  >
    <rect width={52} height={52} y={0.952} fill="#EEF4FF" rx={4} />
    <path
      fill="#5590FF"
      d="M31.3 43.948c1.704 0 3.092-.922 3.12-2.626v-1.34a.67.67 0 0 1 .65-.64h3.5a1 1 0 0 0 1-1s0 2.3-2.67 4.31c-1.601 1.166-3.53 1.351-5.51 1.356l-.09-.06Z"
      opacity={0.598}
    />
    <path
      fill="#D4E4FF"
      stroke="#5590FF"
      strokeLinejoin="round"
      d="M13.59 9.952a1.08 1.08 0 0 0-1.09 1.08v31.836a1.08 1.08 0 0 0 1.09 1.08h17.72a3.12 3.12 0 0 0 3.12-3.07v-1.33a.65.65 0 0 1 .65-.64h3.5a1 1 0 0 0 1-1V11.032a1.08 1.08 0 0 0-1.09-1.08h-24.9Z"
    />
    <path
      stroke="#5590FF"
      d="M26.006 31.952h-.446c-1.186-.168-2.206-.898-2.717-1.944a3.352 3.352 0 0 1 .171-3.26l2.821-4.648a.304.304 0 0 1 .262-.148c.11 0 .21.057.263.148l2.69 4.647c.572.999.6 2.204.077 3.227-.523 1.023-1.532 1.733-2.701 1.902l-.42.076Z"
      clipRule="evenodd"
    />
    <path
      stroke="#5590FF"
      strokeLinecap="round"
      d="M39.57 37.99s.05 2.624-2.62 4.707c-1.601 1.208-3.55 1.246-5.53 1.25"
    />
    <path stroke="#5590FF" d="M15.42 14.952h6-6Z" clipRule="evenodd" />
    <path
      stroke="#5590FF"
      d="M15.42 20.952h6l1.15 1.992M36.992 23.952h-4.85l-1.15 1.992M36.992 31.944h-4.949l-1.05-1.992"
    />
    <path
      stroke="#5590FF"
      d="M15.42 38.952h9-9ZM15.42 40.952h5-5Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgIcMedicalTests;
